import { isServer } from './platform-utils'

export const decodeFromBase64 = (string: string): string => {
    if (isServer) {
        return Buffer.from(string, 'base64').toString()
    }
    return atob(string)
}

export const encodeToBase64 = (string: string): string => {
    if (isServer) {
        return Buffer.from(string).toString('base64')
    }
    return btoa(string)
}

const BASE_URL = process.env.BASE_URL

const isBase64 = (str: string): boolean => {
    if (!str) {
        return false
    }

    try {
        return encodeToBase64(decodeFromBase64(str)) === str
    } catch {
        return false
    }
}

export const getRelativeURL = (url: string, { encoded = true }: { encoded?: boolean } = {}): string => {
    const base = typeof window !== 'undefined' ? window.location.origin : BASE_URL

    if (!url) {
        const fallback = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '/'
        return encoded ? encodeToBase64(fallback) : fallback
    }

    try {
        const decoded = isBase64(url) ? decodeFromBase64(url) : url
        const parsed = new URL(decoded, base)
        const relative = parsed.pathname + parsed.search

        return encoded ? encodeToBase64(relative) : relative
    } catch (error) {
        console.warn('Invalid URL in getRelativeURL:', url, error)
        const fallback = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '/'
        return encoded ? encodeToBase64(fallback) : fallback
    }
}
